import { createContext } from "react";
import useReportTemplatePreviewByIdFilters from "../hooks/data/useReportTemplatePreviewByIdFilters";

export interface IReportTemplatePreviewContext extends ReturnType<typeof useReportTemplatePreviewByIdFilters> {

};

const ReportTemplatePreviewContext = createContext<IReportTemplatePreviewContext >({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ReportTemplatePreviewContext